export function getPostUrl(url: string) {
  if (!url) {
    return "#contact";
  }

  if (url.startsWith("http")) {
    return url;
  }

  return url.startsWith("/") ? url : `/${url}`;
}

export function getAbsolutePostUrl(url: string) {
  const postUrl = getPostUrl(url);

  if (postUrl.startsWith("http")) {
    return postUrl;
  }

  return `https://www.newsclip.co.za${postUrl}`;
}

export function getFullArticleImageUrl(url: string) {
  return url.replace("MainImage_t.jpg", "MainImage.jpg");
}

export function stripHtml(value: string) {
  return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}
